module.exports = __webpack_public_path__ + "static/media/dungeon_floor_sw2.8cecfb73.png";